export class WebGLRenderer {
  canvas: HTMLCanvasElement;
  gl: RenderingContext | null;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    const webglConfig = { alpha: true, premultipliedAlpha: false };
    this.gl = this.canvas.getContext("webgl", webglConfig);
    if (!this.gl) {
      throw new Error("WebGL failed to initialize.");
    }
  }
}

export default WebGLRenderer;
